
import { required } from '~/services/validators';
import formMixin from '~/services/form';

export default {
    name: 'BusinessReject',
    mixins: [formMixin],
    props: {
        business: {
            type: Object,
            required: true,
        },
    },
    methods: {
        async reject() {
            const endpoint = this.$config.endpoints.organisationDecline.replace('{slug}', this.business.slug);
            const { message } = await this.$form.submit(endpoint, '$put', { reason: this.reason });
            this.$store.dispatch('setFlashMessage', { message });
            this.$emit('rejected');
        },
    },
    validations: {
        reason: [required],
    },
};
